export default __webpack_public_path__ + "static/media/13.626ca746.jpg";